
import { defineStore } from 'pinia';
import { ApiService } from 'src/services/api';
import { reactive } from 'vue';
import { StorageService } from '../services/storage';
export const useCalendarStore = defineStore('calendar', () => {
  const state = reactive({
    matriculationOathCalendar: null,
    massSpecialResitCalendar: null,
    finalYearSpecialResitCalendar: null,
  });
  

  async function getMathriculationOathCalendar() {
    try {
      const response = await ApiService.get("academiccalendar/getcalendar/matricualtion_oath");
      const matriculationOathCalendar = response.data;
      
      state.matriculationOathCalendar = matriculationOathCalendar

    }
    catch (err) {
      throw err;
    }
  }

  async function getMassSpecialResitCalendar() {
    try {
      const response = await ApiService.get("academiccalendar/getcalendar/mass_special_resit");
      const massSpecialResitCalendar = response.data;
      
      state.massSpecialResitCalendar = massSpecialResitCalendar

    }
    catch (err) {
      throw err;
    }
  }

  async function getFinalYearSpecialResitCalendar() {
    try {
      const response = await ApiService.get("academiccalendar/getcalendar/final_year_special_resit");
      const finalYearSpecialResitCalendar = response.data;
      
      state.finalYearSpecialResitCalendar = finalYearSpecialResitCalendar

    }
    catch (err) {
      throw err;
    }
  }


  return {
    state,
    getMathriculationOathCalendar,
    getMassSpecialResitCalendar,
    getFinalYearSpecialResitCalendar,
  }
});
